import { countdown } from './state/index';
import { fetchServerTime } from './state/dropClient';

export const host = 'isitalgorandsbirthday.com';

// The old Node WebSocket backend (wallet connect, get-nft, check-availability,
// MongoDB state) has been removed: the 2026 flow connects wallets client-side
// (@txnlab/use-wallet), reads eligibility + claims + supply on-chain (birthday-sdk),
// and gets the token + time from cf-backend. This module now only provides snackbar
// helpers and the countdown time. Legacy (pre-2026) buy routes still call
// query/subscribe/disconnectWallet — those reject/no-op gracefully instead of
// opening a socket to the now-deleted backend.

const RETIRED_MESSAGE = 'This action is no longer available';

class Api {
  enqueueSnackbar;
  doCloseSnackbar;
  snackbarKeys = {};

  // ── retired old-backend RPC (graceful fallbacks for historical routes) ──
  query() {
    return Promise.reject(new Error(RETIRED_MESSAGE));
  }
  subscribe() {
    return Promise.reject(new Error(RETIRED_MESSAGE));
  }
  // Used by 2026 routes as a ConnectButton onDisconnect handler; wallet lifecycle
  // is owned by @txnlab/use-wallet now, so there's nothing for the backend to do.
  disconnectWallet = () => {};

  // ── countdown time (now served by cf-backend /time) ──
  async getServerTime() {
    try {
      this.processServerTime(await fetchServerTime());
    } catch (e) {
      console.log('getServerTime failed', e);
    }
  }
  processServerTime(msg) {
    const { time, bdayStart, bdayEnd } = msg;
    const delta = time - Math.floor(Date.now() / 1000);
    countdown.setServerDiff(delta);
    countdown.setFrom(bdayStart);
    if (bdayEnd) countdown.setBdayEnd(bdayEnd);
  }

  // ── snackbars (unchanged) ──
  enqueue(variant, message, autohide = 4000, key, propsIn) {
    if (this.enqueueSnackbar) {
      if (key && this.snackbarKeys[key]) this.closeSnackbar(key);
      const props = autohide < 1 ? { persist: true } : { autoHideDuration: autohide };
      const propsObj = { variant, ...props, ...propsIn };
      const k = this.enqueueSnackbar(message, propsObj);
      if (key) this.snackbarKeys[key] = k;
    } else {
      alert(message);
    }
  }
  info(...props) {
    return this.enqueue('info', ...props);
  }
  warning(message, autohide = 8000, ...props) {
    return this.enqueue('warning', message, autohide, ...props);
  }
  error(message, autohide = 12000, ...props) {
    this.enqueue('error', message, autohide, ...props);
  }
  closeSnackbar(key) {
    const actualKey = this.snackbarKeys[key];
    if (actualKey) this.doCloseSnackbar(actualKey);
  }
}

const a = new Api();
window._zapi = a;

export default a;
